export default [{
  path: '/compInstructions',
  name: 'compInstructions',
  meta: {
    title: '系统组件使用说明',
    code: 'compInstructions',
    authorized: true,
    structure: 'FULL',
  },
  component: resolve => require(['@/views/compInstructions/index'], resolve)
}]